// Services
import { HttpService } from "@mgs/ci2019-common/src/services/HttpService";

// Store
import { Store } from "#/store";
import { AutosuggestResult } from "../common/interfaces/unimog/AutosuggestResult";
import { AbhHandlersuche } from "../common/interfaces/unimog/AbhHandlersuche";

export class HaendlersucheService {
  private static _instance;

  public static get instance() {
    if (!this._instance) {
      this._instance = new HaendlersucheService();
    }
    return this._instance;
  }

  private constructor() {}

  private readonly http: HttpService = HttpService.instance;

  public async autosuggest(q: string, lat: number, lng: number) {
    let response = await this.http.get<AutosuggestResult>(
      "https://autosuggest.search.hereapi.com/v1/autosuggest",
      {
        params: {
          q: q,
          at: lat + "," + lng,
          apiKey: APP_MAP_API_KEY || "${HERE_MAP_API_KEY}",
          result_types: "address",
        },
      },
      false
    );

    return response.body!;
  }

  public async getHaendler(sparte) {
    let queryUrl = Store.instance.ui.appApiUrl + `haendlersuche/haendler`;

    const response = await this.http.get<any>(queryUrl, {
      params: {
        sparte,
      },
    });

    return response.body!;
  }

  public async getAbh(id, sparte) {
    let queryUrl = Store.instance.ui.appApiUrl + `haendlersuche/abh`;

    const response = await this.http.get<AbhHandlersuche>(queryUrl, {
      params: {
        id,
        sparte,
      },
    });

    return response.body!;
  }
}
